// extracted by mini-css-extract-plugin
module.exports = {"iconSm":"EcgAction_iconSm__2Ftr7","iconWithSeverity":"EcgAction_iconWithSeverity__29o-Y","iconLg":"EcgAction_iconLg__28qHL","severityHeader":"EcgAction_severityHeader__KeJqq"};